"use strict";

import angular from "angular";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { AccountingPlanEntity } from "../../entity/AccountingPlanEntity";
import { nucontersUsers } from "../../utils/users-roles/users-roles";
import { PlanMockNew } from "../../shared/constants/plans.constants";

angular
    .module("nucont.publicVariablesIndicatorsCharts")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.publicvariablesIndicatorsChart", {
            url: "customizacao",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-public-variables-indicators-charts" */ "./public-variables-indicators-charts.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.publicVariablesIndicatorsCharts")
                );
            },
            views: {
                "main@": {
                    component: "adminLayoutComponent"
                },
                "admin@nucont.publicvariablesIndicatorsChart": {
                    component: "publicVariablesIndicatorsChartsComponent"
                }
            },
            data: {
                rolesGuard: [...nucontersUsers],
                layoutConfig: {
                    model: "LayoutConfigModel2"
                }
            },
            resolve: {
                jwtVerified: [
                    "JWTService",
                    (JWTService) => JWTService.verifyTokenOnce()
                ],
                validationsContract: [
                    "NavigationService",
                    (NavigationService) => {
                        const accountingPlanEntity = new AccountingPlanEntity(
                            PlanMockNew
                        );
                        NavigationService.setValidationsContract(
                            accountingPlanEntity
                        );
                    }
                ],
                user: [
                    () => {
                        let count = 0;
                        return new Promise((resolve) => {
                            const checkUser = () => {
                                if (count > 3) return resolve(true);
                                if (new UserDataAdapter().user()?.role) {
                                    return resolve(true);
                                } else {
                                    setTimeout(() => {
                                        count++;
                                        checkUser();
                                    }, 500);
                                }
                            };
                            checkUser();
                        });
                    }
                ]
            }
        })
        .state("nucont.publicvariablesIndicatorsChart.variables", {
            url: "/admin/variaveis",
            views: {
                "tableContent@nucont.publicvariablesIndicatorsChart": {
                    component: "managerPublicVariablesComponent"
                }
            }
        })
        .state("nucont.publicvariablesIndicatorsChart.indicators", {
            url: "/admin/indicadores",
            views: {
                "tableContent@nucont.publicvariablesIndicatorsChart": {
                    component: "managerPublicIndicatorsComponent"
                }
            }
        })
        .state("nucont.publicvariablesIndicatorsChart.charts", {
            url: "/admin/graficos",
            params: {
                openDialogInsert: null
            },
            views: {
                "tableContent@nucont.publicvariablesIndicatorsChart": {
                    component: "managerPublicChartsComponent"
                }
            }
        });
}
